<template>
  <div v-if="visible && available.length" class="pdv-screensaver" aria-label="Mix da Vila — mercado e padaria">
    <img v-for="(slide, index) in available" :key="slide.src" v-show="index === current"
      :src="slide.src" :alt="slide.alt" draggable="false" />
  </div>
</template>

<script>
import { startScreensaver } from './utils/screensaver.mjs';

const slides = [
  { src: "/images/screensaver/Bateu a fome_ Coxinha e hamburgão.png", alt: "Bateu a fome_ Coxinha e hamburgão" },
  { src: "/images/screensaver/Pausa com croissant de frango.png", alt: "Pausa com croissant de frango" },
  { src: "/images/screensaver/Pães dourados em bandejas perfuradas.png", alt: "Pães dourados em bandejas perfuradas" },
  { src: "/images/screensaver/Um doce momento na padaria.png", alt: "Um doce momento na padaria" },
];

export default {
  data: () => ({ visible: false, available: [], current: 0 }),
  mounted() {
    this.disposed = false;
    // Only show successfully loaded images; network failure never hides the PDV.
    Promise.all(slides.map(slide => new Promise(resolve => {
      const image = new Image();
      image.onload = () => resolve(slide);
      image.onerror = () => resolve(null);
      image.src = slide.src;
    }))).then(loaded => {
      if (this.disposed) return;
      this.available = loaded.filter(Boolean);
      if (!this.available.length) return;
      this.stopScreensaver = startScreensaver({
        onShow: () => {
          this.visible = true;
          this.rotation = window.setInterval(() => {
            this.current = (this.current + 1) % this.available.length;
          }, 10000);
        },
        onHide: () => {
          this.visible = false;
          window.clearInterval(this.rotation);
        },
      });
    });
  },
  beforeDestroy() {
    this.disposed = true;
    if (this.stopScreensaver) this.stopScreensaver();
    window.clearInterval(this.rotation);
  },
};
</script>

<style scoped>
.pdv-screensaver {
  position: fixed;
  inset: 0;
  z-index: 2147483647;
  background: #160f09;
  cursor: none;
  user-select: none;
}
.pdv-screensaver img {
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: contain;
}
</style>
